export const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://yaatri-5v36.onrender.com/api';
export const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || 'https://yaatri-5v36.onrender.com';

export const TRAVEL_CLASSES = [
  { code: '1A', name: 'First AC' },
  { code: '2A', name: 'Second AC' },
  { code: '3A', name: 'Third AC' },
  { code: 'SL', name: 'Sleeper' },
  { code: 'CC', name: 'Chair Car' },
  { code: '2S', name: 'Second Sitting' },
  { code: 'GN', name: 'General' },
];

export const QUOTA_TYPES = [
  { code: 'GN', name: 'General' },
  { code: 'TQ', name: 'Tatkal' },
  { code: 'PT', name: 'Premium Tatkal' },
  { code: 'LD', name: 'Ladies' },
  { code: 'HP', name: 'Handicapped' },
];

export const TRAIN_TYPES = {
  RAJDHANI: { label: 'Rajdhani', color: '#EF4444' },
  SHATABDI: { label: 'Shatabdi', color: '#F59E0B' },
  'VANDE BHARAT': { label: 'Vande Bharat', color: '#06B6D4' },
  DURONTO: { label: 'Duronto', color: '#8B5CF6' },
  SUPERFAST: { label: 'Superfast', color: '#2563EB' },
  EXPRESS: { label: 'Express', color: '#10B981' },
  PASSENGER: { label: 'Passenger', color: '#6B7280' },
} as const;

export const SEAT_STATUS_COLORS: Record<string, string> = {
  AVAILABLE: '#10B981',
  RAC: '#F59E0B',
  WL: '#EF4444',
  NOT_AVAILABLE: '#6B7280',
};

export const CACHE_KEYS = {
  SEARCH_RESULTS: 'searchResults',
  USER_PROFILE: 'userProfile',
  SEARCH_HISTORY: 'searchHistory',
  SAVED_ROUTES: 'savedRoutes',
  BOOKMARKS: 'bookmarks',
} as const;

export const POPULAR_ROUTES = [
  { from: { code: 'NDLS', name: 'New Delhi' }, to: { code: 'MMCT', name: 'Mumbai Central' } },
  { from: { code: 'NDLS', name: 'New Delhi' }, to: { code: 'HWH', name: 'Howrah' } },
  { from: { code: 'NDLS', name: 'New Delhi' }, to: { code: 'MAS', name: 'Chennai Central' } },
  { from: { code: 'NDLS', name: 'New Delhi' }, to: { code: 'BCT', name: 'Bangalore' } },
  { from: { code: 'HWH', name: 'Howrah' }, to: { code: 'MMCT', name: 'Mumbai Central' } },
  { from: { code: 'MAS', name: 'Chennai Central' }, to: { code: 'BCT', name: 'Bangalore' } },
];
